export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/analysis.worker.15542e3c.worker.js");
}
